/**
 * Kod felismerese sima szovegben.
 *
 * Miert kell: a kollegak beillesztik a hibauzenetet vagy a lekerdezest, es a
 * chat bekezdesekke torve, aranyos betukkel mutatja - a behuzas elveszik, a
 * hosszu sorok tordelodnek, es a masolas visszafele mar nem ugyanazt adja.
 *
 * A dontes SZANDEKOSAN ovatos: inkabb hagyunk kodot szovegnek, mint hogy egy
 * tobbsoros mondatot kodblokkba zarjunk. Az utobbi zavaro, az elobbi csak
 * elmaradt kenyelem - es a ``` billentyuparanccsal barmikor potolhato.
 */
/** Ennyi jelnel hosszabb kod mar kulon limitet kap (lasd MAX_CODE_LENGTH). */
export const CODE_MIN_LINES = 2;
/**
 * Nyelv-ujjlenyomatok.
 *
 * A sorrend szamit: ami elorebb van, az specifikusabb. A JSON pl. korabban
 * dol el, mint a JavaScript, kulonben minden JSON JavaScript lenne.
 */
const LANGUAGE_HINTS = [
    { language: 'json', pattern: /^\s*[[{][\s\S]*[\]}]\s*$/, weight: 3 },
    {
        language: 'sql',
        pattern: /\b(select|insert into|update|delete from|create table)\b/i,
        weight: 3,
    },
    { language: 'html', pattern: /<\/?(html|div|span|body|head|table|script)\b/i, weight: 3 },
    { language: 'xml', pattern: /^\s*<\?xml\b/i, weight: 4 },
    { language: 'css', pattern: /^[^\n]*\{[^}]*:[^}]*;[\s\S]*\}/, weight: 2 },
    { language: 'python', pattern: /^\s*(def|class)\s+\w+.*:\s*$/m, weight: 3 },
    { language: 'python', pattern: /^\s*(import|from)\s+\w+/m, weight: 1 },
    {
        language: 'csharp',
        pattern: /\b(using System|namespace|public class|var\s+\w+\s*=\s*new)\b/,
        weight: 3,
    },
    {
        language: 'java',
        pattern: /\b(public\s+static\s+void\s+main|System\.out\.println)\b/,
        weight: 3,
    },
    { language: 'php', pattern: /<\?php|\$\w+\s*=/, weight: 3 },
    {
        language: 'bash',
        pattern: /^\s*(#!\/bin\/(ba)?sh|sudo |apt |npm |pnpm |docker |git )/m,
        weight: 2,
    },
    { language: 'yaml', pattern: /^\s*[\w-]+:\s*(\||>|$)/m, weight: 1 },
    {
        language: 'typescript',
        pattern: /\b(interface|type)\s+\w+\s*[={]|:\s*(string|number|boolean)\b/,
        weight: 3,
    },
    { language: 'javascript', pattern: /\b(function|const|let|var)\s+\w+|=>/, weight: 2 },
];
/** Altalanos kod-jelek - nyelvtol fuggetlenul. */
const CODE_SIGNALS = [
    // Sorvegi pontosvesszo vagy kapcsos zarojel: prozaban gyakorlatilag sosincs.
    { pattern: /[;{}]\s*$/m, weight: 2 },
    // Behuzas - legalabb ket sor elejen.
    { pattern: /^[ \t]{2,}\S[\s\S]*?\n[ \t]{2,}\S/m, weight: 2 },
    { pattern: /=>|::|->|&&|\|\||!==|===/, weight: 2 },
    { pattern: /^\s*(\/\/|#|\/\*|--)\s/m, weight: 1 },
    { pattern: /\w+\([^)]*\)\s*[;{]/, weight: 2 },
    { pattern: /<\/?\w+[^>]*>/, weight: 1 },
    { pattern: /^\s*(at |Error:|Exception|Traceback|\s+File ")/m, weight: 3 },
];
/**
 * Proza-ellenjelek.
 *
 * Egy tobbsoros magyar level is tartalmazhat kettospontot es zarojelet.
 * Ezek a mintak azt mutatjak, hogy MONDATOKAT olvasunk - ilyenkor nem
 * nyulunk a szoveghez.
 */
const PROSE_SIGNALS = [
    // Mondatvegi irasjel utan szokoz es nagybetu - tipikus folyoszoveg.
    { pattern: /[.!?]\s+[A-ZÁÉÍÓÖŐÚÜŰ]/, weight: 2 },
    // Ekezetes betuk: kodban ritkak, magyar szovegben szinte biztosak.
    { pattern: /[áéíóöőúüűÁÉÍÓÖŐÚÜŰ]{3,}/, weight: 2 },
];
/**
 * Kod-e a beillesztett szoveg, es ha igen, milyen nyelvu?
 *
 * Egysoros szoveget sosem minositunk kodnak: egy sor onmagaban tul keves
 * bizonyitek, es a sorkozi `code` jeloles arra amugy is jobb.
 */
export function detectCode(text) {
    const trimmed = text.replace(/\s+$/, '');
    const lines = trimmed.split('\n');
    if (lines.length < CODE_MIN_LINES)
        return { isCode: false, language: null };
    let score = 0;
    for (const signal of CODE_SIGNALS) {
        if (signal.pattern.test(trimmed))
            score += signal.weight;
    }
    for (const signal of PROSE_SIGNALS) {
        if (signal.pattern.test(trimmed))
            score -= signal.weight;
    }
    /**
     * A nyelv-egyezes SULYA szamit, nem a puszta tenye.
     *
     * A "SELECT ... FROM ... WHERE" gyakorlatilag bizonyitek; egy `nev:` kezdetu
     * sor (YAML-gyanu) viszont egy bevasarlolistan is elofordul. Ezert a tippet
     * a sajat sulyaval adjuk a pontszamhoz, nem egyseges egyessel.
     */
    const hint = bestHint(trimmed);
    if (hint)
        score += hint.weight;
    return { isCode: score >= 4, language: hint?.language ?? null };
}
/** A nyelv tippje mar felismert kodhoz - a cimkehez es a masolashoz. */
export function guessLanguage(text) {
    return bestHint(text)?.language ?? null;
}
function bestHint(text) {
    let best = null;
    for (const hint of LANGUAGE_HINTS) {
        if (!hint.pattern.test(text))
            continue;
        if (!best || hint.weight > best.weight)
            best = { language: hint.language, weight: hint.weight };
    }
    return best;
}
/** Ember szamara olvashato nyelvnev a kodblokk cimkejehez. */
export function languageLabel(language) {
    if (!language)
        return 'kod';
    return LANGUAGE_LABELS[language] ?? language;
}
const LANGUAGE_LABELS = {
    bash: 'shell',
    csharp: 'C#',
    css: 'CSS',
    html: 'HTML',
    java: 'Java',
    javascript: 'JavaScript',
    json: 'JSON',
    php: 'PHP',
    python: 'Python',
    sql: 'SQL',
    typescript: 'TypeScript',
    xml: 'XML',
    yaml: 'YAML',
};
//# sourceMappingURL=code.js.map